<section class="np-ai-set-section">
  <header class="np-ai-set-section-head">
    <div>
      <h6>내 기억</h6>
      <p>AI가 나에 대해 기억하는 것입니다. 대화에서 "기억해 줘"라고 하거나 여기서 직접 적을 수 있습니다.</p>
    </div>
    <span class="np-ai-set-count" *ngIf="limits.maxItems">{{ memories.length }} / {{ limits.maxItems }}</span>
  </header>

  <!-- 추가 -->
  <div class="np-ai-set-add">
    <textarea rows="2" [(ngModel)]="newContent" [maxlength]="limits.maxLength || 500" [disabled]="busy || full"
      [placeholder]="full ? '기억이 가득 찼습니다. 필요 없는 기억을 지우세요.' : '예: 답은 표로 정리해 주기를 원한다'"
      (keydown)="onAddKeydown($event)"></textarea>
    <button type="button" class="btn btn-sm btn-primary" (click)="add()" [disabled]="!newContent.trim() || busy || full">
      <i class="bi bi-plus-lg"></i> 추가
    </button>
  </div>

  <div *ngIf="errorText" class="np-ai-set-error"><i class="bi bi-exclamation-circle"></i> {{ errorText }}</div>

  <!-- 목록 -->
  <div *ngIf="loading" class="np-ai-set-empty">불러오는 중…</div>
  <div *ngIf="!loading && memories.length === 0" class="np-ai-set-empty">아직 기억이 없습니다.</div>

  <ul class="np-ai-set-memories">
    <li *ngFor="let m of memories; trackBy: trackById" [class.editing]="editingId === m.id">
      <ng-container *ngIf="editingId !== m.id; else editTpl">
        <span class="np-ai-set-memory-text">{{ m.content }}</span>
        <span class="np-ai-set-memory-actions">
          <button type="button" title="수정" (click)="startEdit(m)" [disabled]="busy"><i class="bi bi-pencil"></i></button>
          <button type="button" title="지우기" (click)="remove(m)" [disabled]="busy"><i class="bi bi-trash3"></i></button>
        </span>
      </ng-container>
      <ng-template #editTpl>
        <textarea rows="2" [(ngModel)]="editContent" [maxlength]="limits.maxLength || 500"
          (keydown)="onEditKeydown($event, m)"></textarea>
        <span class="np-ai-set-edit-actions">
          <button type="button" class="btn btn-sm btn-primary" (click)="saveEdit(m)" [disabled]="!editContent.trim() || busy">저장</button>
          <button type="button" class="btn btn-sm btn-light" (click)="cancelEdit()">취소</button>
        </span>
      </ng-template>
    </li>
  </ul>

  <div class="np-ai-set-foot" *ngIf="memories.length">
    <button type="button" class="np-ai-set-danger" (click)="removeAll()" [disabled]="busy">
      <i class="bi bi-trash3"></i> 모두 지우기
    </button>
  </div>
</section>
